import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { MiroLogo } from '@mirohq-internal/website-ui-foundation';

const BrandAttributionBlock = ({ size = 'md' })=>{
    const year = new Date()?.getFullYear() || '';
    return jsxs("div", {
        className: "d-inline-flex align-items-end gap-100",
        children: [
            jsx("div", {
                children: jsx(MiroLogo.Emblem, {
                    className: classNames('icon', {
                        [`icon-size`]: !size,
                        [`icon-size-${size}`]: size
                    })
                })
            }),
            jsxs("div", {
                className: classNames('text-nowrap', {
                    'display-6': size === 'lg',
                    p: size === 'md',
                    small: size === 'sm'
                }),
                children: [
                    "Miro \u00A9 ",
                    year
                ]
            })
        ]
    });
};

export { BrandAttributionBlock };
